import React from 'react';
import clsx from 'clsx';
import * as style from './loading-indicator.css';
import LoadingBars from './loading-bars';

/* This is very, very bad JSX and should be fixed in a chore */
/* Setting inline styles using props is bad */
const InlineLoadingIndicator = ({ className, backgroundColor = '', zIndex }) => (
  <div className={clsx(style.inlineLoading, className)} style={{ zIndex, backgroundColor }}>
    <LoadingBars />
  </div>
);

export default InlineLoadingIndicator;
